import { LeadStatus } from "../enums/lead-status";
// Define deprecated status IDs
const DEPRECATED_STATUSES = [
    LeadStatus.ExpiredCompetition,
    LeadStatus.ExpiredIncorrectlyRegistered,
    LeadStatus.ExpiredNotKnown,
    LeadStatus.ExpiredPrice,
    LeadStatus.ExpiredOrderViaOtherQuotation,
];
// Define active status IDs (for new selections)
const ACTIVE_STATUSES = [
    LeadStatus.New,
    LeadStatus.Quotation,
    LeadStatus.Signed,
    LeadStatus.Completed,
    LeadStatus.Remark,
    LeadStatus.Special,
    LeadStatus.InReview,
    LeadStatus.Assign,
    LeadStatus.InProgress,
    LeadStatus.NoQuotationSubmitted,
    LeadStatus.LostQuotation,
    LeadStatus.AfgerondRichtingPlanning,
];
/**
 * Checks if a status is deprecated
 */
export const isDeprecatedStatus = (status) => {
    return DEPRECATED_STATUSES.includes(status);
};
/**
 * Gets the list of statuses to show in dropdown
 * @param currentStatus - The current status value (if editing existing lead)
 * @returns Array of status values to display
 */
export const getAvailableStatuses = (currentStatus) => {
    // If current status is deprecated, include it in the list
    if (currentStatus && isDeprecatedStatus(currentStatus)) {
        return [...ACTIVE_STATUSES, currentStatus];
    }
    return ACTIVE_STATUSES;
};
/**
 * Status configuration for dropdown display
 */
export const leadStatusConfig = [
    { value: LeadStatus.New, translationKey: "New" },
    { value: LeadStatus.Quotation, translationKey: "Quotation" },
    { value: LeadStatus.Signed, translationKey: "Signed" },
    { value: LeadStatus.Completed, translationKey: "Completed" },
    { value: LeadStatus.Remark, translationKey: "Remark" },
    { value: LeadStatus.Special, translationKey: "Special" },
    { value: LeadStatus.InReview, translationKey: "InReview" },
    { value: LeadStatus.Assign, translationKey: "Toewijzen" },
    // New statuses
    { value: LeadStatus.InProgress, translationKey: "Onderhanden" },
    { value: LeadStatus.NoQuotationSubmitted, translationKey: "Geen offerte uitgebracht" },
    { value: LeadStatus.LostQuotation, translationKey: "Verloren offerte" },
    { value: LeadStatus.AfgerondRichtingPlanning, translationKey: "Afgerond richting planning" },
    // Deprecated statuses (for display only)
    { value: LeadStatus.ExpiredCompetition, translationKey: "Verlopen – concurrentie", deprecated: true },
    { value: LeadStatus.ExpiredIncorrectlyRegistered, translationKey: "Verlopen – foutief ingeschreven", deprecated: true },
    { value: LeadStatus.ExpiredNotKnown, translationKey: "Verlopen – niet bekend", deprecated: true },
    { value: LeadStatus.ExpiredPrice, translationKey: "Verlopen – prijs", deprecated: true },
    { value: LeadStatus.ExpiredOrderViaOtherQuotation, translationKey: "Verlopen – opdracht via andere offerte", deprecated: true },
];
/**
 * Gets the configuration for statuses to display in dropdown
 * @param currentStatus - The current status value (if editing existing lead)
 * @returns Array of status configurations to display
 */
export const getStatusOptionsForDropdown = (currentStatus) => {
    const availableStatuses = getAvailableStatuses(currentStatus);
    return leadStatusConfig.filter(config => availableStatuses.includes(config.value));
};
